import React, { ButtonHTMLAttributes } from "react";

export const TableMenuButton = React.memo(function TableMenuButton(props: Props) {
    const {
        className,
        disabled,
        onClick,
        icon,
        label
    } = props;

    return (
        <button className={`menu_buttons__item ${className ?? ""}`} disabled={disabled} onClick={onClick}>
            {icon}
            <p>{label}</p>
        </button>
    );
});

type Props = ButtonHTMLAttributes<any> & {
    icon: JSX.Element
    label: string
};
